<template>
<v-content class="spinelab-website-front">
  <v-container fluid>
    <v-flex xs12 sm12 md10 lg10 xl10 offset-md1 offset-lg1 offset-xl1>
      <v-layout row>
        <h1>テンプレートからベースデザインを選択</h1>
        <template v-if="!hasSiteId">
          <v-spacer/>
          <v-btn @click="signout()">
            ログアウト
          </v-btn>
        </template>
      </v-layout>
      <v-layout justify-space-between row wrap v-if="initiated">
        <template v-for="industryType in industryTypes">
            <v-flex xs6 sm6 md5 lg3 xl3 :key="industryType">
              <v-btn flat
                     :class="{ [$style['selected-type']] : selectedType == industryType }"
                     @click="selectIndustryType(industryType)">
                {{ industryType }}
              </v-btn>
            </v-flex>
        </template>
      </v-layout>
      <v-layout justify-space-between row wrap v-if="initiated">
        <v-flex xs12 sm12 md5 lg3 xl3
                v-for="template in templates"
                :key="template.id">
          <v-card>
            <v-flex>
              <v-card-media :src="template.image_s3_file_url"
                            height="300px"
                            contain>
              </v-card-media>
            </v-flex>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="dialogue(template)" color="success">
                選択
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-dialog v-model="dialog" max-width="500px">
          <v-card class="spinelab-website-front" v-if="!confirmedTemplate">
            <v-flex md10 offset-md1>
              <v-card-media :src="selectedTemplate.image_s3_file_url"
                            height="500px"
                            contain>
              </v-card-media>
            </v-flex>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="cancelDialogue()">
                キャンセル
              </v-btn>
              <v-btn @click="selectTemplate()"
                     :loading="loading"
                     color="success">
                このデザインをベースに作成する
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
          <v-card class="spinelab-website-front" v-else>
            <v-card-title>
              <h2>サイトのURL(アドレス)を決めましょう</h2>
            </v-card-title>
            <v-card-text>
              <v-layout row>
                <p>https://</p>
                <v-text-field
                   v-model="domain"
                   hint="半角英数字の小文字と-(ハイフン)のみご利用いただけます。"
                   :error-messages="errorMessages"
                   persistent-hint
                   :loading="loading"
                   required>
                </v-text-field>
                <p>.bsj.jp</p>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="cancelDialogue()">
                キャンセル
              </v-btn>
              <v-btn @click="selectDomain"
                     :loading="loading"
                     color="success">
                次へ
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-flex>
  </v-container>
</v-content>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
  name: 'TemplateSelection',
  data() {
    return {
      initiated: false,
      selectedType: '卸・小売業',
      selectedTemplate: '',
      confirmedTemplate: '',
      domain: '',
      dialog: false,
      loading: false,
      errorMessages: [],
      allTemplates: [],
    };
  },
  computed: {
    ...mapState({
      requests: state => state.requests,
      siteId: state => state.siteId,
    }),
    ...mapGetters(['hasSiteId', 'isAdminLogined']),

    templates() {
      return this.allTemplates && this.allTemplates.find(
        template =>
          template.industry_label === this.selectedType).templates;
    },
    industryTypes() {
      return this.allTemplates && this.allTemplates.map(
        template =>
          template.industry_label);
    },
  },
  methods: {
    ...mapActions(['createSite', 'changeTemplate', 'logout']),
    selectIndustryType(industryType) {
      this.selectedType = industryType;
    },
    async signout() {
      await this.logout();
      if (this.isAdminLogined) {
        this.$router.push({ name: 'AdminUsers' });
        return;
      }
      this.$router.push({ name: 'Login' });
    },
    dialogue(template) {
      this.dialog = true;
      this.selectedTemplate = template;
      this.confirmedTemplate = '';
    },
    cancelDialogue() {
      this.dialog = false;
      this.selectedTemplate = '';
      this.confirmedTemplate = '';
    },
    async selectTemplate() {
      if (this.hasSiteId) {
        this.loading = true;
        const payload = {
          templateId: this.selectedTemplate.id,
        };
        await this.changeTemplate(payload);
        this.loading = false;
        this.dialog = false;
      } else {
        this.confirmedTemplate = this.selectedTemplate;
      }
    },
    async selectDomain() {
      this.errorMessages = [];
      this.loading = true;
      const payload = {
        host: `${this.domain}.bsj.jp`,
        templateId: this.confirmedTemplate.id,
      };
      const result = await this.createSite(payload);
      if (!result) {
        this.loading = false;
        this.errorMessages = ['このドメインはすでに使われています'];
        return;
      }
      this.$router.push('website/basic');
    },
  },
  async created() {
    const templates = await this.requests.getTemplates();
    if (!templates) {
      return;
    }
    this.allTemplates = templates;
    this.initiated = true;
  },
};
</script>

<style module>
.selected-type {
  border-bottom: 2px solid green;
}
</style>



// WEBPACK FOOTER //
// src/components/TemplateSelection.vue